/* eslint-disable react-hooks/exhaustive-deps */
import Core from '../Core';
import { styled } from '@mui/system';
import { toast } from 'react-toastify';
import colors from '../../styles/colors';
//@ts-ignore
import styles from './styles.module.css';
import * as api from '../../services/api';
import { useAuth } from '../../hooks/useAuth';
import { useReactToPrint } from 'react-to-print';
import ShareIcon from '@mui/icons-material/Share';
import ArticleIcon from '@mui/icons-material/Article';
import useWindowSize from '../../hooks/useWindowSize';
import { UserProps } from '../User/types';
import InfoPrice2 from '../../components/plateChassiInfo';
import { DefaultMessage } from '../../utils/defaultMessages';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  ModelResponseProps,
  ModelYearProps,
  MounterResponseProps,
} from './types';
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  CircularProgress,
  Radio,
  Typography,
} from '@mui/material';
import { getReCaptchaToken, loadReCaptchaScript, removeReCaptchaScript } from '../../utils/Recaptcha';
import { useLocation } from 'react-router-dom';
import CustomSelect from '../../components/CustomSelect';
import ProductChipsHistories from '../../utils/ProductChips';
import ProductCard from '../../components/ProductCard';
// import BrandVehicle from './BrandVehicle';
import ProductChipDashboard from '../../components/ProductChipDashboard';
import { PrimaryButton } from '../../components/PrimaryButton';
import { ButtonInverse } from '../../components/ButtonInverse';
// import PlateOrChassi from './PlateOrChassi';

// interface ReferenceItem {
//   year_reference: number;
//   month_reference: number;
// }

interface InfoPrice2Props {
  data: {
    content: {
      hash: string;
      values: {
        type: string;
        year: number;
        model: string;
        value: number | null;
        mounter: string | null;
        date_time: string;
        somos_code: string | null;
        year_reference: number;
        month_reference: number;
        aggregates_1?: { codigo_fipe?: string } | null;
        aggregates_2?: any;
      }[];
      pricing?: any;
    }
  };
  reference?: React.RefObject<HTMLInputElement>;
}

export default function Dashboard(): JSX.Element {
  const { user } = useAuth();
  const { width } = useWindowSize();
  const [smallCardButton, setSmallCardButton] = useState<boolean>(false);
  const [visibleAno, setVisibleAno] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [loadingInput, setLoadingInput] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState<string | null>('');

  const [mounters, setMounters] = useState<undefined | MounterResponseProps>();
  const [models, setModels] = useState<undefined | ModelResponseProps>();
  const [years, setYears] = useState<undefined | ModelYearProps>();
  const [displayToCard, setDisplayToCard] = useState('none');
  const [isLoading, setIsLoading] = useState(true);

  const [product, setProduct] = useState<undefined | string>();
  const [mounter, setMounter] = useState<string>('mounter');
  const [model, setModel] = useState<string>('model');
  const [year, setYear] = useState<string>('');

  const [price, setPrice] = useState<undefined | InfoPrice2Props>();
  const [userData, setUserData] = useState<UserProps>();

  const [card, setCard]: [string, (newValue: string) => void] = useState('');
  const [placa, setPlaca]: [string, (newValue: string) => void] = useState('');
  const [codsomos, setCodsomos]: [string, (newValue: string) => void] = useState('none');
  const [hash, setHash]: [string, (newValue: string) => void] = useState('');
  const [codSomosError, setCodSomosError]: [string, (newValue: string) => void] = useState('');
  // const [codSomosDisabled, setCodSomosDisabled] = useState(true);

  const [hashError, setHashError]: [string, (newValue: string) => void] = useState('');
  const [chassi, setChassi]: [string, (newValue: string) => void] =
    useState('');

  const componentRef = useRef<HTMLDivElement>(null);
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const location = useLocation();

  const [monthsOptions, setMonthsOptions] = useState<{ id: string, label: string, month: string, year: string, isDefault: boolean }[]>([]);
  const [yearsModelOptions, setYearsModelOptions] = useState<{ id: string, label: string }[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<string>('none');
  const [selectedYear, setSelectedYear] = useState<string>('none');
  const [selectedMontYear, setSelectedMontYear] = useState<string>('none');
  const [selectedYearModel, setSelectedYearModel] = useState<string>('none');

  const monthNames = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];
  useEffect(() => {
    let isMounted = true;

    if (location.pathname === '/') {
      loadReCaptchaScript().then(() => {
        getReCaptchaToken()
          .then((token) => {
            if (isMounted) setRecaptchaToken(token);
          })
          .catch((err) => console.error('Erro ao gerar token:', err));
      });
    }

    return () => {
      isMounted = false;
      if (location.pathname === '/') removeReCaptchaScript();
    };
  }, [location.pathname]);

  useEffect(() => {
    const updateToken = (e: CustomEvent) => {
      setRecaptchaToken(e.detail);
    };
    window.addEventListener('recaptcha:update', updateToken as EventListener);
    return () => {
      window.removeEventListener('recaptcha:update', updateToken as EventListener);
    };
  }, []);

  const handlePrint = useReactToPrint({
    content: () => {
      if (componentRef.current) {
        return componentRef.current;
      }
      return null;
    },
  });

  const CustomRadio = styled(Radio)(({ theme }) => ({
    '& .MuiSvgIcon-root': {
      color: 'white',
      background: 'white',
      borderRadius: '1rem',
      border: '3px solid white',
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      color: 'rgb(0, 174, 239)',
      background: 'rgb(0, 174, 239)',
    },
  }));

  async function handleCardSelected(value: string) {
    setYear('')
    setVisibleAno(true)
    setLoadingInput(true)
    if (userData?.plan_balance.tr_balance !== null) {
      if (
        value === '1' &&
        userData?.plan_balance.tr_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    if (userData?.plan_balance.hp_balance !== null) {
      if (
        value === '2' &&
        userData?.plan_balance.hp_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    if (userData?.plan_balance.sr_balance !== null) {
      if (
        value === '3' &&
        userData?.plan_balance.sr_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    if (userData?.plan_balance.cr_balance !== null) {
      if (
        value === '4' &&
        userData?.plan_balance.cr_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    if (userData?.plan_balance.cm_balance !== null) {
      if (
        value === '5' &&
        userData?.plan_balance.cm_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    if (userData?.plan_balance.hv_balance !== null) {
      if (
        value === '6' &&
        userData?.plan_balance.hv_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    if (userData?.plan_balance.lw_balance !== null) {
      if (
        value === '7' &&
        userData?.plan_balance.lw_balance! < 1 &&
        userData?.plan_balance.plan === '2'
      ) {
        return toast.error('Saldo insuficiente!');
      }
    }
    setCard(value);
    setProduct(undefined);
    clearSearch()
    setYearsModelOptions([])
    setMonthsOptions([])
    setModels(undefined)
    if (value === '7') {
      setSelectedOptions('brandVehicle')
    } else {
      setSelectedOptions('brandModelYear')
    }
    setPrice(undefined);
    setProduct(value);
    if (value === '5') {
      await getMounters(value);
      setLoadingInput(false)
    }
    await getReference(value)
    setVisibleAno(true)
    setSmallCardButton(true);
  }

  const clearSearch = () => {
    setMounter('mounter');
    setModel('model');
    setHash('')
    // setSelectedMonth('none')
    // setSelectedYear('none')
    // setSelectedMontYear('none')
    // setSelectedYearModel('none')
    setHashError('')
    setCodSomosError('')
    setYear('');

    setCodsomos('none')
    setChassi('');
  }
  const products = user?.products;

  const orderedProducts = [...(user?.products ?? [])].sort(
    (a, b) => Number(a) - Number(b)
  );

  const getMounters = async (product: string, { month, year }: any = {}) => {
    try {
      if (product === '5') {
        const response: any = await api.get(`table/search/trucks/`);
        setMounters(response.data);
        setSelectedYear('');
        setSelectedMonth('');
        setSelectedMontYear('none');
        return;
      }

      const url = month && year
        ? `table/search/mounter/${product}/?year_reference=${year}&month_reference=${month}`
        : `table/search/mounter/${product}/`;

      const response: any = await api.get(url);
      setMounters(response.data);
      setMounter('mounter');
    } catch (error) {
      toast.error(DefaultMessage.ERROR, { position: toast.POSITION.TOP_RIGHT });
    } finally {
    }
  };

  const getReference = async (product: string) => {
    if (product === '5') {
      return setIsLoading(false);
    }
    if (product === '7') {
      setLoadingInput(false)
    }

    try {
      const response: any = await api.get(`table/search/reference-dates/${product}/`);
      const refs = response.data.results || [];

      // Mapeia e marca o primeiro como default
      const mappedOptions = refs.map((item: any, index: number) => ({
        id: `${monthNames[item.month_reference - 1]}/${item.year_reference}`,
        label: `${monthNames[item.month_reference - 1]}/${item.year_reference}`,
        month: item.month_reference,
        year: item.year_reference,
        isDefault: index === 0,
      }));

      setMonthsOptions(mappedOptions);

      if (mappedOptions.length > 0) {
        const defaultOption = mappedOptions[0];
        setSelectedMontYear(defaultOption.id);
        setSelectedYear(defaultOption.year)
        setSelectedMonth(defaultOption.month)
        await getMounters(product, {
            month: defaultOption.month,
            year: defaultOption.year
          });
      }

    } catch (error) {
      console.error("Erro ao buscar referências:", error);
    } finally {
      setIsLoading(false);
      setLoadingInput(false)
    }
  };

  const handleChassiChange = async (e: SelectChangeEvent<string>) => {
    var regex = /^[a-zA-Z0-9\s\b]*$/;
    let value = e.target.value;
    if (regex.test(value)) {
      setChassi(value);
    }
  };

  const getCodSomosConsultation = async () => {
    await loadReCaptchaScript();
    const freshToken = await getReCaptchaToken('query_somos');
    setLoading(true)
    setRecaptchaToken(freshToken);
    if (freshToken)
      try {
        const response: any = await api.get(`/query_somos_code/consultation/${product}/${codsomos}/?year_model=${selectedYearModel}&year_reference=${selectedYear}&month_reference=${selectedMonth}`, undefined, { recaptcha_token: freshToken })
        if (response.status === 200) {
          setPrice(response);
        } else {
          const message = response?.data?.content || DefaultMessage.ERROR;
          toast.error(message);
        }
      } catch (error: any) {
        const message = error.data.detail || DefaultMessage.ERROR
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } finally {
        setCodsomos('none')
        setCodSomosError('')
        setSelectedMonth('none')
        setSelectedYear('none')
        setSelectedYearModel('none')
        setLoading(false)
        await getUserData()
      }
  };

  const getHashConsultation = async () => {
    setLoading(true);

    try {
      const response: any = await api.get(`log/log/response/${hash}/`);
      const { status, data } = response;

      if (status !== 200) {
        const message = data?.detail || DefaultMessage.ERROR;
        toast.error(message);
        return;
      }
      setPrice(response);

    } catch (error: any) {
      const message = error?.data?.detail || DefaultMessage.ERROR;
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setLoading(false);
      setHash('');
    }
  };


  const handleChangeMounter = async (e: SelectChangeEvent<string>) => {
    let value = e.target.value;
    setMounter(value);
    setVisibleAno(true)
    setModel('model')
    setYear('')
    setYears(undefined)
    if (value === 'mounter') return;
    await getModels(value);
  };

  const getModels = useCallback(

    async (mounterCode: string) => {
      if (product === '5') {
        await api
          .get(`table/search/trucks/${mounterCode}/`)
          .then((response: any) => {
            setModels(response.data);
          })
          .catch((error) => {
            toast.error(DefaultMessage.ERROR, {
              position: toast.POSITION.TOP_RIGHT,
            });
          });
      } else {
        try {

          // const url = product !== "7"
          //   : `table/search/codes/${product}/${mounterCode}/`;
          const url = `table/search/codes/${product}/${mounterCode}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`;

          const response: any = await api.get(url);
          setModels(response.data);

        } catch {
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    },
    [product, selectedYear, selectedMonth],
  );

  const handleChangeModel = async (e: SelectChangeEvent<string>) => {
    const value = e.target.value;
    setModel(value);
    setYear('')
    if (value === 'model') return;
    await getYears(value);
  };

  const getYears = useCallback(
    async (modelCode: string) => {
      if (product === '5') {
        await api
          .get(`table/search/trucks/${mounter}/${modelCode}/`)
          .then((response: any) => {
            setYears(response.data);
            const list = response.data.content?.years || [];
            if (list.length === 0) {
              setVisibleAno(false);
              setYear('no-years');
            } else {
              setVisibleAno(true);
              setYear('');
            }

          })
          .catch((error) => {
            toast.error(DefaultMessage.ERROR, {
              position: toast.POSITION.TOP_RIGHT,
            });
          });
      } else {
        try {
          // const url = product !== "7"
          //   ? `table/search/model/${product}/${modelCode}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`
          //   : `table/search/model/${product}/${modelCode}/`;
          const url = `table/search/model/${product}/${modelCode}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`;
          
          const response: any = await api.get(url);
          setYears(response.data);
          const list = response.data.content?.years || [];
          if (list.length === 0) {
            setVisibleAno(false);
            setYear('no-years');
          } else {
            setVisibleAno(true);
            setYear('');
          }

        } catch {
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    },
    [product, mounter],
  );

  useEffect(() => {
    if (visibleAno) {
      setYear('');
    }
  }, [visibleAno]);

  const getPrice = useCallback(async () => {
    await loadReCaptchaScript();
    const freshToken = await getReCaptchaToken('search_price');
    setLoading(true)
    setRecaptchaToken(freshToken);
    if (freshToken)
      if (product === '5') {
        await api
          .get(`table/search/trucks/${mounter}/${model}/${year}/`, undefined, { recaptcha_token: freshToken })
          .then(async (response: any) => {

            if (response.status === 403 && userData?.plan_balance?.plan === '1') {
              return toast.error(response?.data?.content, {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
            setCard('');
            setPrice(response);
            setCard('');
            await getUserData();
          })
          .catch((error) => {
            toast.error(DefaultMessage.ERROR, {
              position: toast.POSITION.TOP_RIGHT,
            });
          });
      } else {
        if (freshToken) {
          try {
            const url = product !== "7"
              ? `table/search/model/price/${product}/${model}/${year}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`
              : `table/search/model/price/${product}/${model}/${selectedYear}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`;

            const response: any = await api.get(url, undefined, { recaptcha_token: freshToken });
            if (response.status === 403 && userData?.plan_balance?.plan === '1') {
              toast.error(response?.data?.content, {
                position: toast.POSITION.TOP_RIGHT,
              });
              setLoading(false)
              return
            }
            if (response.status === 403 || response.status === 429) {
              toast.error(response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT,
              });
              setLoading(false)
              return

            }
            setCard('');
            setPrice(response);
            setCard('');
            await getUserData();

          } catch {
            toast.error(DefaultMessage.ERROR, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }

      }
    setLoading(false)
  }, [product, model, year, mounter, selectedYear, selectedMonth]);

  const getUserData = useCallback(async () => {
    await api
      .get(`user/retrieve/${user?.id}/`)
      .then((response: any) => {
        setUserData(response.data.content);
        setDisplayToCard('flex');
      })
      .catch((error) => {
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [user]);

  const getPlateOrChassiPrice = async () => {
    setLoading(true)
    await loadReCaptchaScript();
    const freshToken = await getReCaptchaToken('table_price');
    setRecaptchaToken(freshToken);
    const findBy = placa !== '' ? placa : chassi;
    if (freshToken)
      try {
        const url = `/table/search/pricing/3/?year_reference=${selectedYear}&month_reference=${selectedMonth}`;

        const response: any = await api.get(url, { chassi_or_plate: findBy }, { recaptcha_token: freshToken });
        if (response.status === 200) {
          setIsLoading(false);
          setCard('');
          setPrice(response);
        } else if (response.status === 206) {
          setIsLoading(false);
          setCard('');
          setPrice(response);
        }
        toast.error(response.data.content, {
          position: toast.POSITION.TOP_RIGHT,
        });

      } catch {
        setCard('3');
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    setLoading(false)
    setPlaca('')
    setSelectedMonth('none')
    setSelectedMontYear('none');
    setSelectedYear('none')
    setChassi('')
    await getUserData();
  };

  const getPlateOrChassiPriceTruckBus = async () => {
    setIsLoading(true);
    await loadReCaptchaScript();
    const freshToken = await getReCaptchaToken('check_view');
    setRecaptchaToken(freshToken);
    const findBy = placa !== '' ? placa : chassi;
    if (freshToken)
      await api
        .post(`/check_view/checkview/query/5/`, { chassi_or_plate: findBy }, { recaptcha_token: freshToken })
        .then((response: any) => {
          if (response.status === 200) {
            setIsLoading(false);
            setCard('');
            setPrice(response)
          } else if (response.status === 400 || response.status === 500) {
            setIsLoading(false);
            setCard('5');
            toast.error(response.data.content || response.data.content.error, {
              position: toast.POSITION.TOP_RIGHT,
            });
            setPlaca('');
            setChassi('');
          }
        })
        .catch((error) => {
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsLoading(false);
          setCard('5');
        });
    setPlaca('')
    setChassi('')
    await getUserData();
  };

  useEffect(() => {
    if (products?.length === 1) {
      handleCardSelected(products[0]);
    }
    getUserData();
  }, [getUserData, products, user]);

  const getCodSomosYearModel = async (product: string, somosCode: string) => {
    try {
      const url = `query_somos_code/list/year_model/${product}/${somosCode}/?year_reference=${selectedYear}&month_reference=${selectedMonth}`;

      const response: any = await api.get(url);

      if (response.status === 200) {
        const refs = response.data.content.years
        setYearsModelOptions(
          refs.map((year: number) => ({
            id: String(year),
            label: String(year),
          }))
        );
      } if (response.status === 206) {
        setCodSomosError(response.data.content.detail);
      }
      if (response.status === 404) {
        setCodSomosError(response.data.content);
      }

    } catch (error: any) {
      const message = error.data.content.detail || DefaultMessage.ERROR

      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }

  const handleCodSomosChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const pattern = /^\d{6}-\d$/;

    setCodsomos(value);

    if (!pattern.test(value)) {
      setCodSomosError("Código inválido. Use o formato 123456-1");
    } else {
      setCodSomosError("");
      if (product)
        await getCodSomosYearModel(product, value)
    }
  };

  const handleHashChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setHash(value);

    // Regex para validar SHA-256
    const regex = /^[a-fA-F0-9]{64}$/;

    if (!value) {
      setHashError("O hash é obrigatório.");
    } else if (!regex.test(value)) {
      setHashError("Hash inválido. Deve conter exatamente 64 caracteres hexadecimais.");
    } else {
      setHashError(""); // válido
    }
  };

  const handleChangeYear = async (e: SelectChangeEvent<string>) => {
    let value = e.target.value;
    setYear(value);
  };

  const handleChangeYearModel = (event: any) => {
    const selected = event.target.value as string;
    setSelectedYearModel(selected)
  };

  const handleChangeMonth = async (event: any) => {
    const selectedId = event.target.value;
    const selectedOption = monthsOptions.find(opt => opt.id === selectedId);
    if (!selectedOption) return;

    setSelectedYear(selectedOption.year)
    setSelectedMonth(selectedOption.month)
    setSelectedMontYear(selectedOption.id)
    setMounter('mounter');
    setModel('model');
    setYear('');

    if (!product) return;

    await getMounters(product, {
        month: selectedOption.month,
        year: selectedOption.year
    });
  };

  const mapChips = [
    ...(product !== "7" ? [{ id: "brandModelYear", label: "MARCA/MODELO/ANO" }] : []),
    ...(card === "5" || card === "3")
      && (card === "5"
        ? userData?.can_query_chassi_or_plate_bus_truck
        : userData?.can_query_chassi_or_plate)
      && !isLoading
      ? [{ id: "plateOrChassi", label: "PLACA/CHASSI" }]
      : [],
    ...(product !== "5" && product !== "7" ? [{ id: "cod_somos", label: "COD. SOMOS" }] : []),
    ...(product === "7" ? [{ id: "brandVehicle", label: "MARCA/VEÍCULO" }] : []),
    { id: "hash", label: "HASH" },
  ]

  return (
    <Core withBlueBar withNavbar>
      <Grid
        container
        rowGap={2}
        columnGap={4}
        sx={{ zIndex: 2 }}
        alignItems="center"
        // top={smallCardButton ? 90 : 30}
        height={smallCardButton ? 'auto' : '70vh'}
        position={smallCardButton ? 'fixed' : 'relative'}
        // position="relative"
        flexWrap={width < 607 && smallCardButton ? 'nowrap' : 'wrap'}
        maxHeight={width < 607 && smallCardButton ? '90px' : undefined}
        justifyContent={
          width < 607 && smallCardButton ? 'flex-start' : 'center'
        }
        top={smallCardButton ? '94px' : ''}
        style={
          width < 607 && smallCardButton
            ? {
              overflowX: 'scroll',
              overflowY: 'hidden',
              padding: '0 10px',
              paddingBottom: '10px',
            }
            : {}
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: smallCardButton ? "row" : "row",
            overflowX: smallCardButton ? "auto" : "visible",
            overflowY: "hidden",
            whiteSpace: smallCardButton ? "nowrap" : "normal",
            WebkitOverflowScrolling: smallCardButton ? "touch" : "auto",
            scrollbarWidth: smallCardButton ? "none" : "auto",
            marginTop: ".1rem",
            flexWrap: smallCardButton ? "nowrap" : "wrap",
            justifyContent: smallCardButton ? "flex-start" : "flex-start",
            gap: "16px",
          }}
          className={smallCardButton ? "scroll-container" : ""}
        >
          {ProductChipsHistories
            .filter(({ id }) => products?.includes(id))
            .map(({ id, label, icon }) => (
              <div
                key={id}
                style={{
                  flex: smallCardButton ? "0 0 auto" : "1 1 200px",
                  minWidth: smallCardButton ? "80px" : "200px",
                }}
              >
                <ProductCard
                  id={id}
                  name={label}
                  icon={icon}
                  product={product}
                  userData={userData}
                  colors={colors}
                  smallCardButton={smallCardButton}
                  displayToCard={displayToCard}
                  onClick={() => handleCardSelected(id)}
                />
              </div>
            ))}
        </div>

      </Grid>
      {smallCardButton && !userData?.is_admin && !userData?.is_staff ? (
        <Grid
          container
          className={styles.chip}
          // marginTop={25}
          style={{ marginTop: width <= 900 ? '18rem' : '14rem' }}
          marginBottom="3rem"
          textAlign="center"
        >
          {orderedProducts?.map((p: string) => (
            <ProductChipDashboard
              key={p}
              product={p}
              products={orderedProducts}
              userData={userData}
              displayToCard={displayToCard}
            />
          ))}
        </Grid>
      ) : (
        <div></div>
      )}
      {smallCardButton ? (
        !price ? (
          !isLoading ? (
            (
              <Grid
                container
                direction="column"
                textAlign="center"
                alignContent="center"
                width='100%'
                paddingX={width > 600 ? '0%' : '5%'}
                // marginTop={smallCardButton && !userData?.is_admin && !userData?.is_staff ? '2rem' : width <= 900 ? '17rem' : '12rem'}
                gap={2}
                style={
                  (card === '3' || card === '5') &&
                    userData?.can_query_chassi_or_plate &&
                    userData?.can_query_chassi_or_plate_bus_truck &&
                    !isLoading
                    ? {
                      marginTop: '0rem',
                    }
                    : !userData?.is_admin && !userData?.is_staff
                      ? {
                        marginTop: '0rem',
                      }
                      : {
                        marginTop:
                          window.innerWidth <= 900 ? '18rem' : '14rem',
                      }
                }
              >
                <div style={{ width: width > 900 ? '50%' : '90%' }} className='flex flex-col'>
                  <div style={{ marginTop: card === '3' || card === '5' ? '3rem' : '' }} className={styles.optionsCheckContainer}>
                    {
                      mapChips.map((chips, index) => (
                        <div
                          key={index}
                          className={styles.optionCheck}
                          onClick={() => { setSelectedOptions(chips.id); clearSearch() }}
                        >
                          <label
                            style={{
                              minWidth: '100%',
                              width: 'max-content',
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '.9rem',
                            }}
                          >
                            <CustomRadio
                              checked={selectedOptions === chips.id}
                              value={chips.id}
                              name="radio-buttons"
                              inputProps={{ 'aria-label': 'A' }}
                              style={{ pointerEvents: 'none' }}
                            />
                            {chips.label}
                          </label>
                        </div>
                      ))
                    }
                  </div>
                  <div style={{
                    marginTop: '2rem'
                  }}>
                    {loadingInput ? <Grid
                      container
                      direction="column"
                      textAlign="center"
                      alignContent="center"
                      paddingX={width > 600 ? '30%' : '10%'}
                      marginTop={
                        smallCardButton && !userData?.is_admin && !userData?.is_staff
                          ? 5
                          : 25
                      }
                      gap={2}
                    >
                      <CircularProgress size={100} />
                    </Grid> : selectedOptions === "brandModelYear" && (
                      <div className='flex flex-col gap-4'>
                        {product !== '5' && (
                          <div className='flex flex-col md:flex-row w-full gap-4'>
                            <CustomSelect
                              widthProp='100%'
                              name="month_reference"
                              value={selectedMontYear}
                              onChange={(newValue) => handleChangeMonth(newValue)}
                              options={[
                                { id: 'none', label: 'SELECIONE UM MÊS/ANO DE REFERÊNCIA' },
                                ...monthsOptions,
                              ]}
                              multiple={false}
                              showAllOption={false}
                            />
                          </div>
                        )}
                        <FormControl fullWidth>
                          <Select
                            labelId="mounter-label"
                            id="mounter-select"
                            value={mounter}
                            label="Marca"
                            onChange={handleChangeMounter}
                            disabled={product !== '5' && selectedMontYear === 'none'}
                            variant="outlined"
                          >
                            <MenuItem key="mounter-key" value="mounter">
                              SELECIONE UMA MARCA
                            </MenuItem>
                            {mounters?.content.map((item, index) => (
                              <MenuItem
                                key={`mounter-${index}`}
                                value={
                                  item?.mounter_code
                                    ? item?.mounter_code
                                    : item?.codigo
                                }
                              >
                                {item?.mounter ? item?.mounter : item?.nome}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth>
                          <Select
                            value={model}
                            label="Modelo"
                            id="model-select"
                            variant="outlined"
                            labelId="model-label"
                            onChange={handleChangeModel}
                            disabled={mounter === 'mounter'}
                          >
                            <MenuItem key="model-key" value="model">
                              SELECIONE UM MODELO
                            </MenuItem>
                            {models?.content?.map((item, index) => (
                              <MenuItem
                                key={`model-${index}`}
                                value={item.model_code || item.codigo}
                              >
                                {item?.description || item.nome}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth>
                          <Select
                            labelId="year-label"
                            id="year-select"
                            value={
                              years?.content?.years?.length === 0 && !visibleAno
                                ? 'no-years'
                                : year || ''
                            }
                            displayEmpty
                            label="Ano"
                            onChange={handleChangeYear}
                            variant="outlined"
                            disabled={!visibleAno || model === 'model'}
                          >
                            {visibleAno && (
                              <MenuItem key="year-key" value="">
                                SELECIONE UM ANO
                              </MenuItem>
                            )}

                            {years?.content?.years?.length === 0 ? (
                              <MenuItem value="no-years" sx={{ whiteSpace: 'normal' }}>
                                <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                                  Não há anos disponíveis para este modelo.{"\n"}Por favor selecione outro modelo.
                                </Typography>
                              </MenuItem>
                            ) : (
                              years?.content?.years.map((item: any, index: number) => (
                                <MenuItem
                                  value={String(item.codigo || item)}
                                  key={`year-${index}`}
                                >
                                  {isNaN(Math.trunc(parseInt(item.nome || item)))
                                    ? item.nome || item
                                    : Math.trunc(parseInt(item.nome || item))}
                                </MenuItem>
                              ))
                            )}
                          </Select>
                        </FormControl>
                        <PrimaryButton
                          variant="contained"
                          size="large"
                          color="secondary"
                          onClick={getPrice}
                          disabled={!recaptchaToken || loading || selectedMonth === 'none' || selectedYear === 'none' || mounter === 'mounter' || model === 'model' || year === 'no-years' || year === '' || !visibleAno || years?.content?.years?.length === 0}
                        >
                          {loading ? <CircularProgress size={24} color="inherit" /> : 'Buscar'}
                        </PrimaryButton>
                      </div>
                    )}
                    {selectedOptions === "cod_somos" && product !== '5' && (
                      <div className='flex flex-col gap-4'>
                        <div className='flex flex-col md:flex-row w-full gap-4'>
                          <CustomSelect
                            widthProp='100%'
                            name="month_reference"
                            value={selectedMontYear}
                            onChange={(newValue) => handleChangeMonth(newValue)}
                            options={[
                              { id: 'none', label: 'SELECIONE UM MÊS/ANO DE REFERÊNCIA' },
                              ...monthsOptions,
                            ]}
                            multiple={false}
                            showAllOption={false}
                          />
                        </div>
                        <FormControl fullWidth>
                          <TextField
                            disabled={selectedMontYear === 'none'}
                            id="outlined-basic"
                            placeholder="Informe o código somos"
                            value={codsomos === 'none' ? '' : codsomos}
                            onChange={handleCodSomosChange}
                            error={!!codSomosError}
                            helperText={codSomosError}
                            variant="outlined"
                            InputLabelProps={{
                              style: {
                                color: 'black',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: '-15px',
                              },
                            }}
                            inputProps={{
                              style: {
                                textAlign: 'center',
                              },
                            }}
                          />
                        </FormControl>
                        <div className='w-full'>
                          <CustomSelect
                            disabled={codsomos === 'none' || !!codSomosError}
                            name="year_model"
                            value={selectedYearModel}
                            onChange={(newValue) => handleChangeYearModel(newValue)}
                            options={[
                              { id: 'none', label: 'SELECIONE UM ANO MODELO' },
                              ...yearsModelOptions,
                            ]}
                            multiple={false}
                            showAllOption={false}
                            widthProp='100%'
                          />
                        </div>
                        <PrimaryButton
                          variant="contained"
                          size="large"
                          color="secondary"
                          onClick={getCodSomosConsultation}
                          disabled={!recaptchaToken || loading || codsomos === 'none' || selectedYear === 'none' || selectedMonth === 'none' || selectedYearModel === 'none' || !!codSomosError}                                                    >
                          {loading ? <CircularProgress size={24} color="inherit" /> : 'Buscar'}
                        </PrimaryButton>
                      </div>
                    )}
                    {selectedOptions === "hash" && (
                      <div className="flex flex-col gap-4">
                        <FormControl fullWidth>
                          <p style={{ color: "#006991", marginBottom: ".5rem" }}>
                            INFORME O HASH
                          </p>
                          <TextField
                            id="outlined-basic"
                            placeholder="Informe o hash"
                            value={hash}
                            onChange={handleHashChange}
                            error={!!hashError}
                            helperText={hashError}
                            variant="outlined"
                            InputLabelProps={{
                              style: {
                                color: "black",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                top: "-15px",
                              },
                            }}
                            inputProps={{
                              style: {
                                textAlign: "center",
                              },
                            }}
                          />
                        </FormControl>
                        <PrimaryButton
                          variant="contained"
                          size="large"
                          color="secondary"
                          onClick={getHashConsultation}
                          disabled={!recaptchaToken || loading || hashError !== "" || hash === ""}
                        >
                          {loading ? <CircularProgress size={24} color="inherit" /> : 'Buscar'}
                        </PrimaryButton>
                      </div>
                    )}
                    {selectedOptions === "plateOrChassi" && (
                      // <PlateOrChassi product={product} monthsOptions={monthsOptions} selectedMonth={selectedMonth} selectedYear={selectedYear} setCard={setCard} setDisplayToCard={setDisplayToCard} setPrice={setPrice} setSelectedMonth={setSelectedMonth} setSelectedMontYear={setSelectedMontYear} setSelectedYear={setSelectedYear} setUserData={setUserData} />
                      <div className='flex flex-col gap-4'>

                        <FormControl fullWidth></FormControl>
                        {product !== '5' && (
                          <div className='flex flex-col md:flex-row w-full gap-4'>
                            <CustomSelect
                              widthProp='100%'
                              name="month_reference"
                              value={selectedMontYear}
                              onChange={(newValue) => handleChangeMonth(newValue)}
                              options={[
                                { id: 'none', label: 'SELECIONE UM MÊS/ANO DE REFERÊNCIA' },
                                ...monthsOptions,
                              ]}
                              multiple={false}
                              showAllOption={false}
                            />
                          </div>
                        )}
                        <FormControl fullWidth>
                          {/* <p style={{ color: '#006991', marginBottom: '.5rem' }}>
                              INFORME A PLACA OU CHASSI
                            </p> */}
                          <TextField
                            id="outlined-basic"
                            // label={!isFocusedChassi ? 'INFORME A PLACA OU CHASSI AQUI' : ''}
                            placeholder="Informe a placa ou chassi aqui"
                            value={chassi}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                              handleChassiChange(e)
                            }
                            variant="outlined"
                            InputLabelProps={{
                              style: {
                                color: 'black',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: '-15px',
                              },
                            }}
                            inputProps={{
                              style: {
                                textAlign: 'center',
                              },
                            }}
                          />
                        </FormControl>
                        <PrimaryButton
                          variant="contained"
                          size="large"
                          color="secondary"
                          onClick={card === '3' ? getPlateOrChassiPrice : getPlateOrChassiPriceTruckBus}
                          disabled={!recaptchaToken || loading || (placa === '' && chassi === '')}
                        >
                          {loading ? <CircularProgress size={24} color="inherit" /> : 'Buscar'}
                        </PrimaryButton>
                      </div>
                    )}
                    {selectedOptions === "brandVehicle" && product === '7' && (
                      // <BrandVehicle monthsOptions={monthsOptions}/>
                      <div className='flex flex-col gap-4'>
                        <div className='flex flex-col md:flex-row w-full gap-4'>
                          <CustomSelect
                            widthProp='100%'
                            name="month_reference"
                            value={selectedMontYear}
                            onChange={(newValue) => handleChangeMonth(newValue)}
                            options={[
                              { id: 'none', label: 'SELECIONE UM MÊS/ANO DE REFERÊNCIA' },
                              ...monthsOptions,
                            ]}
                            multiple={false}
                            showAllOption={false}
                          />
                        </div>
                        <FormControl fullWidth>
                          <Select
                            labelId="mounter-label"
                            id="mounter-select"
                            value={mounter}
                            label="Marca"
                            onChange={handleChangeMounter}
                            // disabled={product !== '5' && selectedMontYear === 'none'}
                            variant="outlined"
                          >
                            <MenuItem key="mounter-key" value="mounter">
                              SELECIONE UMA MARCA
                            </MenuItem>
                            {mounters?.content.map((item, index) => (
                              <MenuItem
                                key={`mounter-${index}`}
                                value={
                                  item?.mounter_code
                                    ? item?.mounter_code
                                    : item?.codigo
                                }
                              >
                                {item?.mounter ? item?.mounter : item?.nome}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <FormControl fullWidth>
                          <Select
                            value={model}
                            label="Modelo"
                            id="model-select"
                            variant="outlined"
                            labelId="model-label"
                            onChange={handleChangeModel}
                            disabled={mounter === 'mounter'}
                          >
                            <MenuItem key="model-key" value="model">
                              SELECIONE UM MODELO
                            </MenuItem>
                            {models?.content?.map((item, index) => (
                              <MenuItem
                                key={`model-${index}`}
                                value={item.model_code || item.codigo}
                              >
                                {item?.description || item.nome}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <PrimaryButton
                          variant="contained"
                          size="large"
                          color="secondary"
                          onClick={getPrice}
                          disabled={!recaptchaToken || loading || mounter === 'mounter' || model === 'model'}
                        >
                          {loading ? <CircularProgress size={24} color="inherit" /> : 'Buscar'}
                        </PrimaryButton>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            )
          ) : (
            <Grid
              container
              direction="column"
              textAlign="center"
              alignContent="center"
              paddingX={width > 600 ? '30%' : '10%'}
              marginTop={
                smallCardButton && !userData?.is_admin && !userData?.is_staff
                  ? 5
                  : 25
              }
              gap={2}
            >
              <CircularProgress size={100} />
            </Grid>
          )

        ) : (
          <Grid
            container
            direction="column"
            textAlign="center"
            alignItems="center"
            alignContent="center"
            marginY={!userData?.is_admin && !userData?.is_staff ? 5 : 25}
            gap={6}
          >
            {price && (
              <InfoPrice2 reference={componentRef} data={{ content: price.data.content }} />
            )}
            <Grid container justifyContent="center" gap={2}>
              <ButtonInverse
                variant="contained"
                size="large"
                color="secondary"
                onClick={() => handlePrint()}
              >
                <ShareIcon /> &nbsp; Compartilhar
              </ButtonInverse>
              <PrimaryButton
                variant="contained"
                size="large"
                color="secondary"
                onClick={() => {
                  handleCardSelected(product!);
                }}
              >
                <ArticleIcon /> &nbsp; Nova consulta
              </PrimaryButton>
            </Grid>
          </Grid>
        )
      ) : (
        <></>
      )}
    </Core>
  );
}